import React, { useState } from "react";
import Person4Icon from "@mui/icons-material/Person4";
import { MdOutlineLibraryAdd, MdOutlineListAlt } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import "./TableOfContent.css";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const TableOfContent = ({
  setNavToggle,
  navToggle,
  active,
  handelActive,
  contentList,
}) => {
  const { t } = useTranslation("inventory");
  const navigate = useNavigate();
  return (
    <div
      className={!navToggle ? "toc__sidebar_wrapper" : "toc__sidebar_wrapper2"}
    >
      <div className="toc__nav_items_box ">
        {contentList.map(({ heading, i18nKey, menus }, index) => {
          return (
            <div className="toc__nav_items_active" key={index}>
              <div className="toc__sidebar_heading">{i18nKey ? t(i18nKey) : heading}</div>
              {menus.map(({ name, id, i18nKey: nameKey }, mindex) => {
                return (
                  <a
                    className={
                      false
                        ? "toc__mitems_parent active__class"
                        : "toc__mitems_parent"
                    }
                    key={id}
                    href={`#${id}`}
                    // onClick={() =>
                    //   handelActive((index + "_" + mindex).toString())
                    // }
                  >
                    <div className="toc__mitems">{nameKey ? t(nameKey) : name}</div>
                  </a>
                );
              })}

              <div className="toc__divider_line"></div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TableOfContent;
